export const pathwayIcons = {
    leaf: 'leaf', 'people-group': 'people-group', map: 'map', calendar: 'calendar-days',
    tools: 'screwdriver-wrench', book: 'book-open', seedling: 'seedling', water: 'water',
    hand: 'hand-holding-heart', globe: 'earth-oceania', document: 'file-lines'
};

export default function homeDiscovery() {
    // Measure editor-managed copy so the photo always meets the panels' midpoint.
    document.querySelectorAll('.lds-journey-hero + .lds-ghost-wayfinding').forEach(bar => {
        const hero = bar.previousElementSibling;
        if (hero.classList.contains('lds-journey-hero--no-image')) return;
        const updateOverlap = () => hero.style.setProperty('--wayfinding-half-height', `${bar.getBoundingClientRect().height / 2}px`);
        updateOverlap();
        new ResizeObserver(updateOverlap).observe(bar);
    });
    document.querySelectorAll('.lds-ghost-wayfinding-items .kg-callout-card, .lds-journey-creek .kg-callout-card').forEach(card => {
        const links = card.querySelectorAll('a[href]');
        // Stretch only an unambiguous single destination; custom multi-link cards stay intact.
        if (links.length === 1) {
            card.classList.add('lds-ghost-tappable-row');
            links[0].classList.add('lds-ghost-row-link');
        }
        const text = card.querySelector('.kg-callout-text');
        if (!text) return;
        const walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
        let marker;
        while (walker.nextNode()) {
            if (/^Icon:\s*[\w-]+\s*$/i.test(walker.currentNode.textContent.trim())) marker = walker.currentNode;
        }
        if (!marker) return;
        const name = marker.textContent.trim().replace(/^Icon:\s*/i, '').toLowerCase();
        marker.remove();
        while (text.lastChild?.nodeName === 'BR') text.lastChild.remove();
        // Only bundled, documented Free icons may become classes.
        if (!pathwayIcons[name]) return;
        const icon = document.createElement('i');
        icon.className = `fa-solid fa-${pathwayIcons[name]} lds-ghost-wayfinding-icon`;
        icon.setAttribute('aria-hidden', 'true');
        card.prepend(icon);
    });
}
